export default function findInTree(nodes, criteria) {
  return nodes.reduce((result, node) => {
    return result || (criteria(node) ? node : findInTree(node.get('children'), criteria))
  }, undefined)
}
